import { usePermissionContext, useWorkspaceContext } from '../context';

export enum AtsAccess {
  CREATE_NEW_JOBS = 'CREATE_NEW_JOBS',
  JOBS_LISTING = 'JOBS_LISTING',
  TALENT_POOL = 'TALENT_POOL',
  PIPELINE = 'PIPELINE',
  SUBMISSIONS = 'SUBMISSIONS',
  ANALYTICS = 'ANALYTICS',
  VENDORS = 'VENDORS',
  HOT_JOBS = 'HOT_JOBS',
  ACTIVE_CONSULTANTS = 'ACTIVE_CONSULTANTS',
}

export const useAtsAccess = (action: AtsAccess) => {
  const workspace = useWorkspaceContext();
  const permissionContext = usePermissionContext();

  return workspace.owns
    ? true
    : workspace.role &&
        permissionContext.isAuthorized &&
        permissionContext.isAuthorized('ATS_ACCESS', action, [workspace.role]);
};
